import { render, staticRenderFns } from "./EventsFrame.vue?vue&type=template&id=541d93ec&scoped=true"
import script from "./EventsFrame.vue?vue&type=script&lang=js"
export * from "./EventsFrame.vue?vue&type=script&lang=js"
import style0 from "./EventsFrame.vue?vue&type=style&index=0&id=541d93ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541d93ec",
  null
  
)

export default component.exports